import { defineComponent as _defineComponent } from 'vue'
import BaseButton from 'JS/components/BaseButton.vue';
import Icon from 'JS/components/Icon.vue';
import { onMounted, ref, useListeners } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesFlyerSearchForm',
  props: {
    label: null,
    forceResettable: { type: Boolean },
    initialValue: null
  },
  emits: ["submit", "reset"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'submit', value: string): void
	(e: 'reset'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	label: string;
	forceResettable?: boolean
	initialValue?: string;
}





const input = ref<HTMLInputElement | null>(null);
onMounted(() => {
	if (input.value && props.initialValue) {
		input.value.value = props.initialValue;
	}
});

const listeners = useListeners();

function handleSubmit(e: SubmitEvent) {
	if (!listeners.submit) {
		return;
	}

	e.preventDefault();

	const el = e.currentTarget as HTMLFormElement;
	const form = new FormData(el);
	const keyword = form.get('keyword');
	if (typeof keyword !== 'string') {
		return;
	}

	emit('submit', keyword);
}

function handleReset() {
	emit('reset');
	input.value?.focus();
}

return { __sfc: true,props, emit, input, listeners, handleSubmit, handleReset, BaseButton, Icon }
}

})